export const products = {
  title: 'Termékek és szolgáltatások',
  subtitle: 'Termékek kezelése és áttekintése',
  organizations: "Összes szervezet",
  new: "Új termék",
  loading: "Termékek betöltése...",
  noResults: "Nincs találat",
  tryDifferentSearch: "Próbáljon más keresési feltételeket megadni",
  filter: {
    allTypes: "Összes típus",
    products: "Termékek",
    services: "Szolgáltatások",
    packages: "Csomagok",
    category: "Kategória",
    active: "Aktív szűrők"
  },
  types: {
    product: "Termék",
    service: "Szolgáltatás",
    package: "Csomag"
  },
  fields: {
    product: "Termék",
    type: "Típus",
    organizations: "Szervezetek",
    price: "Ár",
    actions: "Műveletek",
    tax: "% ÁFA",
    category: "Kategória",
    category1: "Főkategória",
    category2: "Alkategória",
    status: "Állapot",
    active: "Aktív",
    name: "Név",
    code: "Kód",
    description: "Leírás",
    unit: "Egység",
    netPrice: "Nettó ár",
    grossPrice: "Bruttó ár",
    taxRate: "ÁFA kulcs",
    rounding: "Kerekítés",
    webStore: "Webáruház",
    discontinued: "Kifutó termék",
    reverseTaxation: "Fordított adózás",
    productImage: "Termékkép",
    thumbnailImage: "Előnézeti kép",
    stock: "Készlet",
    articleNumber: "Cikkszám",
    barcode: "Vonalkód",
    vtsz: "VTSZ/TESZOR kód",
    purchasePrice: "Beszerzési ár",
    accountingPrice: "Elszámoló ár"
  },
  sections: {
    details: "Termék adatai",
    categories: "Kategóriák",
    pricing: "Árazás",
    additionalPricing: "További árazási opciók",
    images: "Termékképek",
    productImages: "Termékképek",
    hiddenImages: "Rejtett képek (csak adminisztrátorok)",
    additionalImages: "További képek",
    inventory: "Készlet összesítő",
    inventoryDetails: "Készlet részletek",
    stockMovements: "Készletmozgások"
  },
  validation: {
    nameRequired: "A név megadása kötelező",
    codeRequired: "A kód megadása kötelező",
    codeAvailable: "✓ A kód elérhető",
    codeInUse: "❌ A kód már használatban van",
    codeCheckInProgress: "Kód ellenőrzése folyamatban...",
    waitForCodeCheck: "Kérjük, várja meg a kód ellenőrzés befejezését.",
    codeAlreadyInUse: "A termékkód már használatban van. Kérjük, válasszon másik kódot."
  },
  codeGeneration: {
    autoGenerated: "(automatikusan generált)",
    placeholder: "YPR-00001, YSE-00001 vagy YPA-00001 (generált, felülírható)",
    helpText: "💡 A kód automatikusan generált típus alapján (YPR: termék, YSE: szolgáltatás, YPA: csomag), de tetszés szerint módosíthatja"
  },
  units: {
    piece: "Darab",
    kg: "Kilogramm",
    liter: "Liter",
    meter: "Méter",
    package: "Csomag",
    box: "Karton",
    hour: "Óra",
    day: "Nap",
    month: "Hónap"
  },
  tooltips: {
    duplicate: "Másolat készítése",
    edit: "Szerkesztés",
    delete: "Törlés",
    view: "Részletek megtekintése",
    copy: "Másolás",
    inventory: "Készlet megtekintése"
  },
  messages: {
    deleteConfirm: 'Biztosan törli ezt a terméket?',
    noMoreOrgs: 'Nincs több hozzáadható szervezet',
    confirmTitle: 'Termék törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt a terméket?',
    deleteWarning: 'Ez a művelet nem visszavonható.'
  },
  copy: "Másolás",
  edit: "Szerkesztés",
  delete: "Törlés",
  view: "Megtekintés",
  inventory: "Készlet",
  moreActions: "További műveletek",
  deactivate: "Deaktiválás",
  noCategories: "Nincsenek elérhető kategóriák",
  noSubcategories: "Nincsenek elérhető alkategóriák",
  selectedCategory: "Kiválasztott kategória",
  uploadImage: "Kép feltöltése",
  uploadingImage: "Kép feltöltése...",
  imageInstructions: "A képnek JPG vagy PNG formátumúnak kell lennie, max. 5MB méretben.",
  form: {
    add: "Új termék létrehozása",
    edit: "Termék szerkesztése",
    type: {
      title: "Termék típusa",
      product: "Termék",
      service: "Szolgáltatás",
      package: "Csomag"
    },
    package: {
      includedInPrice: "Benne van az árban"
    },
    basicInfo: {
      title: "Termék adatai",
      name: "Név",
      code: "Kód",
      description: "Leírás",
      unit: "Egység",
    },
    pricing: {
      title: "Szervezet és árazás",
      price: "Ár",
      currency: "Pénznem",
      taxRate: "ÁFA kulcs (%)",
    },
    selectCategory: "Válasszon főkategóriát",
    selectSubcategory: "Válasszon alkategóriát",
    selectTaxRate: "Válasszon adókulcsot",
    buttons: {
      add: "Termék hozzáadása",
      update: "Termék módosítása",
      cancel: "Mégse",
      remove: "Eltávolítás"
    }
  }
}